import React, { Component } from 'react';
import { Button, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

import EcardImage from './ecard_icon.png';

class ECardWidget extends Component {
    render() {
        const enableFeature = this.props && this.props.configBenefit && this.props.configBenefit.featuresConfig && this.props.configBenefit.featuresConfig.allowEcard
        return (
            enableFeature ? (<Link to="/app/ecards">
                <Button
                    basic
                    fluid
                >
                    <Image src={EcardImage} fluid/>
                    Access my eCard
                </Button>
            </Link>) :
            <Button
                disabled={true}
                basic
                fluid
            >
                <Image src={EcardImage} fluid/>
                Access my eCard
            </Button>
        );
    }
}

export default ECardWidget;
